import { render, staticRenderFns } from "./CommercialCompanyTable.vue?vue&type=template&id=0054742c"
import script from "./CommercialCompanyTable.vue?vue&type=script&lang=js"
export * from "./CommercialCompanyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports